




































































































import Vue from 'vue';
import { dateFormat, dateTransactionFormat } from '@/constants';

import AccountExportTools from '@/components/account-components/account-export-tools/account-export-tools.component.vue';
import { Claim, ClaimsPaymentResponseModel, TableHeader } from '@/@types/member';
import { EopPDF } from '@/mixins/pdf-mixins';
import { ExtendMixins } from '@/services';

interface Data {
  dateFormat: string;
  dateTransactionFormat: string;
  headers: TableHeader[];
}

export default ExtendMixins(EopPDF).extend({
  name: 'ExplanationOfPayment',
  props: {
    paymentDetails: {
      type: Object as () => ClaimsPaymentResponseModel,
      required: true,
    },
    headline: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    transactionId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      dateFormat,
      dateTransactionFormat,
      headers: [
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_account',
          ),
          value: 'account',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_source',
          ),
          value: 'source',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_claim-number',
          ),
          value: 'claimNumber',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_service-type',
          ),
          value: 'serviceType',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_patient',
          ),
          value: 'patientName',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_service-from',
          ),
          value: 'serviceStartDate',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_service-to',
          ),
          value: 'serviceEndDate',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_submitted',
          ),
          value: 'submittedAmount',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_approved',
          ),
          value: 'approvedAmount',
          sortable: false,
        },
        {
          text: this.$options.filters.t(
            'account-activity-eop_table-header_reason',
          ),
          value: 'denialReason',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    claims(): Claim[] {
      return this.paymentDetails.claims;
    },
    filename(): string {
      return `explanation-of-payment-${this.transactionId}`;
    },
  },
  methods: {
    formatNotApplicable(denialReason) {
      return denialReason === '<Not Applicable>'
        ? this.$options.filters.t('account-activity-eop_text_na')
        : denialReason;
    },
    createEopPdf() {
      this.createPdf(this.transactionId, this.paymentDetails);
    },
  },
  components: {
    AccountExportTools,
  },
});
